import { LabelsProvider } from "@wine2trace/ui/components";
import useLabels from "../hooks/useLabels";

// Hands the webapp's translations to the components of @wine2trace/ui. Needs the redux Provider,
// AuthProvider and Router above it (useLabels uses them), so it is mounted around <App /> in index.js.
const UiLabelsBridge = ({ children }) => {
  const [getLabel] = useLabels();
  return <LabelsProvider getLabel={getLabel}>{children}</LabelsProvider>;
};

export default UiLabelsBridge;
